module.exports = __webpack_public_path__ + "img/contact-email.7dd036a4.svg";